import React from 'react';

export const name = 'flag-ES';

export const FlagES = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2_150)">
      <mask
        id="mask0_2_150"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <path d="M24 0H0V24H24V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_2_150)">
        <path
          d="M2.8954e-09 12C2.8954e-09 13.4672 0.2625 14.8734 0.75 16.1719L12 17.2172L23.25 16.1719C24.2501 13.4805 24.2501 10.5194 23.25 7.82812L12 6.78281L0.75 7.82812C0.253946 9.16312 -3.13118e-05 10.5758 2.8954e-09 12Z"
          fill="#FFDA44"
        />
        <path
          d="M23.25 7.82812C22.3976 5.53158 20.8627 3.55095 18.8516 2.15229C16.8406 0.753628 14.4496 0.00393677 12 0.00393677C9.55036 0.00393677 7.15941 0.753628 5.14838 2.15229C3.13728 3.55095 1.60243 5.53158 0.75 7.82812H23.25ZM0.75 16.1719C1.60243 18.4684 3.13728 20.449 5.14838 21.8477C7.15941 23.2463 9.55036 23.9961 12 23.9961C14.4496 23.9961 16.8406 23.2463 18.8516 21.8477C20.8627 20.449 22.3976 18.4684 23.25 16.1719H0.75Z"
          fill="#D80027"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_2_150">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
